
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"205","height":"70","viewBox":"0 0 54.24 18.521"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M53.575 16.841c0-1.122-.211-2.915-.493-4.192-.394-1.782-1.241-4.182-1.612-4.569-.125-.13-1.487-.397-5.246-1.031-2.792-.471-5.113-.856-5.156-.856-.044 0-.08 1.071-.08 2.38v2.38h-1.371l-.027-2.512-.027-2.512-3.173-.546c-1.745-.3-3.204-.514-3.241-.476-.04.039-.085 1.415-.106 3.058l-.04 2.987h-.819l-.82.001V7.727c0-2.116-.038-3.226-.108-3.226-.059 0-1.929-.31-4.156-.687a361.804 361.804 0 00-4.123-.688c-.04 0-.075 1.761-.075 3.914v3.913H21.21V6.881c0-2.24-.01-4.073-.024-4.073-.01 0-1.43-.238-3.146-.529-1.716-.29-3.156-.528-3.2-.528-.043 0-.079 2.07-.079 4.601v4.601h-1.48V1.466l-1.402-.23c-.77-.126-1.497-.228-1.613-.226-.37.006-1.809.694-2.718 1.3-1.083.72-2.511 2.145-3.417 3.408-.375.523-.684.985-.685 1.025-.001.04-.172.365-.38.72-.21.355-.61 1.226-.891 1.936a20.296 20.296 0 00-1.447 6.71L.661 17.51H6.194l.002-.344c.001-.19.072-.673.157-1.075.325-1.535 1.19-2.82 2.221-3.303l.529-.247H45.17l.528.247c1.032.483 1.896 1.768 2.222 3.303.085.402.155.886.156 1.075l.002.344h5.5z","fill":"#f0f0f0"}})])
          )
        }
      }
    